import React, { createContext, useState, useEffect } from "react";

export const FormDataContext = createContext();

const safeParseJSON = (raw) => {
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const FormDataProvider = ({ children }) => {
    const [formData, setFormData] = useState(() => {
        const savedData = safeParseJSON(localStorage.getItem("formData"));
        return savedData || {};
    });
    useEffect(() => {
        localStorage.setItem("formData", JSON.stringify(formData));
    }, [formData]);

    const updateFormData = (newData) => {
        setFormData((prev) => ({ ...prev, ...newData }));
    };
    return (
        <FormDataContext.Provider value={{ formData, updateFormData }}>
            {children}
        </FormDataContext.Provider>
    );
};
